/* NOVELA — RTL slider fix.
   Dawn/Shrine compute slidesPerPage from offsetLeft arithmetic that goes
   negative in RTL, which leaves carousel arrows and dots wrong. The Sense RTL
   app patched this at runtime; this file owns the same patch so the app can be
   removed. Wrapped in try/catch: on pages without SliderComponent it is a
   no-op, never an error in the console.

   The re-run at the end matters: the custom elements upgrade while the theme's
   own script runs, so every slider on the page has already called the broken
   initPages by the time this file executes. */
(function () {
  'use strict';
  function patch() {
    if (typeof SliderComponent === 'undefined' || !SliderComponent.prototype) return false;
    if (SliderComponent.prototype.nvRtlPatched) return true;
    Reflect.defineProperty(SliderComponent.prototype, 'initPages', {
      value: function () {
        if (!this || !this.sliderItems) return;
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(function (el) {
          return el.clientWidth > 0;
        });
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
          Math.abs((this.slider.clientWidth + this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset)
        );
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
      }
    });
    Reflect.defineProperty(SliderComponent.prototype, 'nvRtlPatched', { value: true });
    return true;
  }

  function reinit() {
    document.querySelectorAll('slider-component,slideshow-component').forEach(function (s) {
      try { if (typeof s.initPages === 'function') s.initPages(); } catch (e) { }
    });
  }

  try {
    var tries = 0;
    (function tick() {
      if (patch()) { reinit(); return; }
      if (++tries < 20) setTimeout(tick, 250);
    })();
    window.addEventListener('load', function () { if (patch()) reinit(); });
    document.addEventListener('shopify:section:load', function () { if (patch()) reinit(); });
  } catch (e) { }
})();

/* NOVELA — gift guard.
   The free gifts (glass file, nail guide) are real products priced at zero, so
   before this they could be opened from the cart, added on their own and taken
   through checkout for nothing. Three layers here:
   1. the gift row in the cart drawer is not clickable,
   2. the gift product page cannot add to cart (the cart drawer's own buttons on
      that page are deliberately left alone, so the pen can still be added),
   3. checkout is refused while the cart is worth nothing, and any gift whose
      unlocking product left the cart is removed, with one of each gift max.
   The rules come from the data-nvc-gifts attribute that snippets/nv-cart.liquid
   prints on the cart-drawer element, so the theme editor stays the source of
   truth. Lives in this file because it is one of the few assets loaded on every
   page of the site. */
(function () {
  'use strict';
  if (window.__nvGiftGuard) return;
  window.__nvGiftGuard = true;

  var busy = false;

  function rules() {
    var el = document.querySelector('cart-drawer[data-nvc-gifts]');
    if (!el) return [];
    try { return JSON.parse(el.getAttribute('data-nvc-gifts')) || []; } catch (e) { return []; }
  }

  function style() {
    if (document.getElementById('nv-gift-guard-css')) return;
    var s = document.createElement('style');
    s.id = 'nv-gift-guard-css';
    s.textContent = '.nvc-item--gift .nvc-item-img,.nvc-item--gift .nvc-item-name a{pointer-events:none;cursor:default}';
    document.head.appendChild(s);
  }

  function unlink() {
    var ns = document.querySelectorAll('.nvc-item--gift a[href]');
    for (var i = 0; i < ns.length; i++) {
      ns[i].removeAttribute('href');
      ns[i].setAttribute('aria-disabled', 'true');
    }
  }

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function clean() {
    var g = rules();
    if (!g.length || busy) return getCart();
    busy = true;
    return getCart().then(function (cart) {
      var handles = cart.items.map(function (i) { return i.handle; }).concat(cart.items.map(function (i) { return String(i.variant_id); }));
      var jobs = [];
      cart.items.forEach(function (item) {
        var rule = null;
        for (var i = 0; i < g.length; i++) {
          if (g[i].variant === item.variant_id || g[i].handle === item.handle) { rule = g[i]; break; }
        }
        if (!rule) return;
        var ok = false;
        var un = rule.unlock || [];
        for (var j = 0; j < un.length; j++) {
          if (handles.indexOf(String(un[j]).trim()) !== -1) { ok = true; break; }
        }
        if (!ok) { jobs.push([item.key, 0]); }
        else if (item.quantity > 1) { jobs.push([item.key, 1]); }
      });
      if (!jobs.length) { busy = false; return cart; }
      var p = Promise.resolve();
      jobs.forEach(function (j) { p = p.then(function () { return change(j[0], j[1]); }); });
      return p.then(getCart).then(function (c) { busy = false; return c; });
    }).catch(function () { busy = false; return null; });
  }

  function warn() {
    var box = document.getElementById('CartDrawer-CartErrors');
    if (box) box.textContent = 'המתנות מצטרפות רק עם המוצר שמזכה בהן. הוסיפו אותו לעגלה כדי להמשיך לתשלום.';
  }

  function inDrawer(el) {
    return !!(el && el.closest && el.closest('cart-drawer,#CartDrawer,.nvc,cart-notification'));
  }

  function lockPage() {
    var g = rules();
    if (!g.length) return;
    var path = location.pathname;
    try { path = decodeURIComponent(path); } catch (e) { }
    var hit = false;
    for (var i = 0; i < g.length; i++) {
      if (path.indexOf('/products/' + g[i].handle) === 0) { hit = true; break; }
    }
    if (!hit) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var k = 0; k < forms.length; k++) {
      if (inDrawer(forms[k])) continue;
      forms[k].addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); }, true);
      var btns = forms[k].querySelectorAll('button,input[type=submit]');
      for (var m = 0; m < btns.length; m++) {
        btns[m].disabled = true;
        btns[m].setAttribute('aria-disabled', 'true');
      }
    }
    var sticky = document.querySelectorAll('[class*="sticky-atc"],[id*="sticky-atc"]');
    for (var s = 0; s < sticky.length; s++) {
      if (inDrawer(sticky[s])) continue;
      sticky[s].style.display = 'none';
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest
      ? e.target.closest('#CartDrawer-Checkout,[name="checkout"],a[href="/checkout"]')
      : null;
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    clean().then(function (c) {
      if (!c || c.item_count === 0 || c.total_price <= 0) {
        warn();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return;
      }
      window.location.href = '/checkout';
    });
  }, true);

  function boot() {
    style();
    unlink();
    lockPage();
    clean();
    var root = document.getElementById('CartDrawer');
    if (root && window.MutationObserver) {
      new MutationObserver(unlink).observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      setTimeout(function () { unlink(); clean(); }, 300);
    });
  });
})();
